import { render, staticRenderFns } from "./doOrders.vue?vue&type=template&id=603c127e&xmlns%3Av=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./doOrders.vue?vue&type=script&lang=js&"
export * from "./doOrders.vue?vue&type=script&lang=js&"
import style0 from "./doOrders.vue?vue&type=style&index=0&id=603c127e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports